import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import CONSTANTS from '../utils/constants';
import errorCircle from "../assets/img/success-error-pages/error_circle.svg";

const GeneralErrorWidget: React.FC<{ customMessage?: string }> = ({ customMessage }) => {

  useEffect(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });    
  }, []);

  return (
    <div className='d-flex error-widget widget-wrapper'>
      <div className='d-flex'>
        <img src={errorCircle} className="error-widget-circle" alt="Error" data-testid="error-widget-circle" />
      </div>
      

    <div className='d-flex flex-column widget-text'>
        <h5 className='volte-semibold widget-heading' data-testid='pm-widget-primary-text'>
          <FormattedMessage id={CONSTANTS.ERROR_WIDGET.PRIMARY} defaultMessage="Something went wrong" />
        </h5>
        <p className='volte-medium widget-sub-heading' data-testid='pm-widget-secondary-text'>
          <FormattedMessage id={customMessage === "CUSTOM_ERROR_PAYPAL" ? CONSTANTS.ERROR_WIDGET.PAYPAL_SECONDARY : CONSTANTS.ERROR_WIDGET.SECONDARY} defaultMessage="Please try another payment method."/>
        </p>
      </div>
    </div>
  )
}

export default GeneralErrorWidget;